export function getSessionInfo () {
  return fetch('/actions/users/session-info', {
    headers: {
      'Accept': 'application/json',
    },
  })
    .then(response => response.json());
}
